// extracted by mini-css-extract-plugin
module.exports = {"htLogo":"htlogo_htLogo__oyy9f","defaultCursor":"htlogo_defaultCursor__uPsKW"};